module.exports = __webpack_public_path__ + "static/media/grey.78e240f2.png";